<template>
  <el-dialog
    :title="type === 'add' ? '新增干预' : '编辑干预'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="30%"
    center
  >
    <el-form label-width="auto">
      <el-form-item label="客户号" class="demo-form-inline headLabel" required>
        <el-select
          v-model="form.kehuId"
          size="small"
          placeholder="请选择客户号"
          @change="changeKehu"
        >
          <el-option
            :label="item.cusNo"
            :value="item.cusNo"
            v-for="item in projectList"
            :key="item.cusId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道号" class="demo-form-inline headLabel" required>
        <el-select
          v-model="form.qudaoId"
          size="small"
          placeholder="请选择渠道号"
          @change="changeQudao"
        >
          <el-option
            :label="item.channelName"
            :value="item.channelName"
            v-for="item in qudaoList"
            :key="item.channelId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目号" class="demo-form-inline headLabel" required>
        <el-select
          v-model="form.xiangmuId"
          size="small"
          placeholder="请选择项目号"
        >
          <el-option
            :label="item.projectName"
            :value="item.projectName"
            v-for="item in xiangmuList"
            :key="item.projectId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="最小版本" class="demo-form-inline" required>
        <el-input
          v-model.trim="form.marketId"
          placeholder="请输入最小版本号"
        ></el-input>
      </el-form-item>
      <el-form-item label="最大版本" class="demo-form-inline" required>
        <el-input
          v-model.trim="form.marketMax"
          placeholder="请输入最小版本号"
        ></el-input>
      </el-form-item>

      <el-form-item label="手机型号：" required>
        <div class="Languagelist">
          <el-select
            v-model="form.channelId"
            placeholder="请选择型号"
            @change="changedeviceName"
          >
            <el-option
              :disabled="i.status == 1"
              :label="i.deviceName"
              :value="i.deviceName"
              v-for="i in deviceList"
              :key="i.id"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="关键词：" required>
        <el-input
          v-model.trim="form.keyword"
          placeholder="请输入关键词"
        ></el-input>
      </el-form-item>
      <el-form-item label="版位：" required>
        <el-radio v-model="form.keywordType" :label="2">搜索联想</el-radio>
        <el-radio v-model="form.keywordType" :label="1">搜索结果</el-radio>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getProJectList } from "@/api/ozBlockConf";
import { addKeywordConfig, updateKeywordConfig } from "@/api/searchIntervene";
import { mapGetters } from "vuex";
export default {
  props: { isShow: Boolean, row: Object, type: String },
  computed: {
    ...mapGetters(["deviceList"]),
    dialogVisible: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit("update:isShow", val);
      },
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.row) {
        this.form = { ...this.row };
      } else {
        this.form = this.$options.data().form;
      }
    },
  },
  data() {
    return {
      projectList: [], //项目号
      qudaoList: [], //渠道号
      xiangmuList: [], //项目号

      keywordType: 1,
      form: {
        channelId: "",
        keyword: "",
        keywordType: 1,
        kehuId: null,
        qudaoId: null,
        xiangmuId: null,
      },
    };
  },
  async created() {
    this.$store.dispatch("updateDeviceList");
    this.projectList = await this.getProJectDataList({ type: 1 });
    if (this.row) {
      this.form = { ...this.form, ...this.row };
    }
  },
  methods: {
    async changeKehu(val) {
      this.form.channelName = "";
      this.form.xiangmuId = "";
      if (val == "") {
        this.qudaoList = [];
        this.xiangmuList = [];
      }
      this.qudaoList = await this.getProJectDataList({
        cusNo: val == "ALL" ? "" : val,
        type: 2,
      });
    },
    async changeQudao(val) {
      this.form.xiangmuId = "";
      if (val == "") {
        this.xiangmuList = [];
      }
      this.xiangmuList = await this.getProJectDataList({
        cusNo: this.form.kehuId == "ALL" ? "" : this.form.kehuId,
        channelName: val == "ALL" ? "" : val,
        type: 3,
      });
    },
    async getProJectDataList(obj) {
      let res = await getProJectList({ page: 1, size: 3000, ...obj });
      if (res.code == 0) {
        let list = res.data.list || [];
        if (list.length > 0) {
          list.unshift({
            projectId: -1,
            cusNo: "ALL",
            channelName: "ALL",
            projectName: "ALL",
          });
        }
        return list;
      }
    },
    fetchList() {},
    changedeviceName(val) {
      // let deviceName = this.deviceList.find((item) => {
      //   return item.id == val;
      // });
      // this.form.deviceName = deviceName.deviceName;
    },
    save() {
      if (!this.form.channelId) {
        this.$message.warning("请选择型号");
        return;
      }
      if (!this.form.keyword) {
        this.$message.warning("请输入关键词");
        return;
      }
      // this.form.deviceName = this.deviceList.find(
      //   (d) => d.id === this.form.channelId
      // ).deviceName;
      if (this.type === "edit") {
        updateKeywordConfig(this.form).then((res) => {
          this.$message.success("编辑成功");
          this.dialogVisible = false;
          this.$parent.getDataList();
        });
      } else {
        addKeywordConfig(this.form).then((res) => {
          this.$message.success("新增成功");
          this.dialogVisible = false;
          this.$parent.getDataList();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
